import { getApiURL } from '@b2b-frontend/utils/env';
import axios from 'axios';
import { PAGE_CATEGORY } from '@b2b-frontend/utils/analytics/constants';
import type { ILearnBrandStoryProps } from 'views/learn/LearnBrandStory/component';

export const getServerSideProps = async (
	context,
): Promise<{
	props: ILearnBrandStoryProps;
}> => {
	const { brandName, storyId } = context.params;
	const apiURL = getApiURL(context.req.headers?.referer || '');

	const [brandResponse, storyResponse] = await Promise.all([
		await axios.get(`${apiURL}/brands/${brandName}`),
		await axios.get(`${apiURL}/brands/${brandName}/stories/${storyId}`),
	]);

	return {
		props: {
			...brandResponse.data.data,
			story: storyResponse.data.data,
			dataLayerSeed: {
				pageCategory: PAGE_CATEGORY.CONTENT_BRANDING,
			},
		},
	};
};

export { default } from 'views/learn/LearnBrandStory';
